import { setup } from 'axios-cache-adapter';

import localforage from 'localforage';
import http from './http';

/**
 * Create an instance of axios with a configured cache adapter.
 *
 * @param {String} prefix for cache keys in storage backend
 * @param {Number} ttl in minutes for cached items
 */
function axiosWithCache(prefix, ttl) {
  const store = localforage.createInstance({
    driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
    // Prefix all storage keys to prevent conflicts
    name: prefix,
  });
  const MINUTE = 60 * 1000;

  const axios = setup({
    baseURL: http.baseURL,
    withCredentials: true,
    cache: {
      maxAge: ttl * MINUTE,
      exclude: {
        // don't exclude reqs with query params
        query: false,
      },
      store,
    },
  });

  return axios;
}

export default axiosWithCache;
